/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { useState } from 'react'
import { Spacer } from '@cleartrip/bento'
import {
  getCurrencyByReq
} from 'AccountsUtils'
import Cross from 'AccountsIcons/cross.svg'
import ToolTip from './ToolTip'
import { SVGComponent } from '.'

const FareRulesWidget = ({ data = null, isRefundFareRule = false, onClose = () => { }, marginTop }) => {
  const CANCEL_BETWEEN = 'Cancel Between'
  const CHANGE_BETWEEN = 'Change Between'
  const AMOUNT_REFUNDABLE = 'Amount Refundable'
  const DATE_CHANGE_CHARGES = 'Date Change Charges'
  const NON_CHANGEABLE = 'Non changeable'
  let cancelationPolicyBlock = ''
  let dateChangePolicyBlock = ''
  const [currentTooltipData, setCurrentTooltipData] = useState(null)
  const { fareDetails, indexOfFaq = 0 } = data || {}
  const {
    departureCity,
    arrivalCity,
    departureTime,
    fareRules,
    currency,
    isSplRt = false,
    disclaimerText = ''
  } = fareDetails || {}
  const disclaimerTextArray = disclaimerText && disclaimerText.split('/')
  const onFareRulesClick = toolTipdata => {
    setCurrentTooltipData(null)
    if (toolTipdata) {
      setCurrentTooltipData(toolTipdata)
    }
  }
  const getTooltipContent = (fields = [], totalRefundable) => {
    const tooltipContent = fields.map((field, index) => {
      const { groupName, chargesBreakup = [] } = field
      return (

        <div>
          <If condition={groupName}>
            <div className="flex flex-between w-210 c-grey-30 pt-1">
              <div className="fs-2 fw-600 tt-uppercase ">{groupName}</div>
            </div>
          </If>
          <If condition={chargesBreakup && chargesBreakup.length > 0}>
            {
              chargesBreakup.map(
                (charge, idx) => {
                  const { totalAmount, name, code, paxWiseBreakup = [] } = charge
                  return (

                    <If condition={totalAmount && name}>
                      <div className="flex flex-between w-210 c-white fw-600">
                        <div className={`${code === 'AMOUNT_PAID' ? 'fs-3' : 'fs-2'}`}>{name}</div>
                        <div className={`${code === 'AMOUNT_PAID' ? 'fs-3' : 'fs-2'}`} style={{ lineHeight: '18px' }}>
                          {getCurrencyByReq(totalAmount, currency)}
                        </div>

                      </div>

                      <If condition={paxWiseBreakup && paxWiseBreakup.length > 0 && code !== 'CLTP_CANCEL_CHARGE' && code !== 'CON_FEE'}>
                        {paxWiseBreakup.map(
                          paxCharge => {
                            const { paxCount, paxType, chargePerPax } = paxCharge
                            return (

                              <div className="flex flex-between w-210 c-white pl-4 fw-600">
                                <div className="fs-1" style={{ display: 'list-item' }}>{`${paxType === 'ADT' ? 'Adult ' : paxType === 'CHD' ? 'Child ' : 'Infant '}(${getCurrencyByReq(chargePerPax, currency)}x${paxCount})`}</div>
                                <div className="fs-1" style={{ lineHeight: '18px' }}>
                                  {getCurrencyByReq(chargePerPax * paxCount, currency)}
                                </div>
                              </div>

                            )
                          }
                        )}
                      </If>
                    </If>

                  )
                }
              )
            }
          </If>
        </div>

      )
    })
    return (
      <div className="flex flex-column">
        {tooltipContent}
        <div className="flex flex-between w-210 c-white mt-2 pt-2 fw-600" style={{ borderTop: '1px solid' }}>
          <div className="fs-3">{AMOUNT_REFUNDABLE}</div>
          <div className="fs-3" style={{ lineHeight: '18px' }}>
            {getCurrencyByReq(totalRefundable, currency)}
          </div>
        </div>
      </div>
    )
  }
  const getFourSegmentBlock = (
    title1,
    title2,
    timeSegement = [],
    priceSegment = [],
    tooltipContentSegment = [],
    showInfo = false
  ) => (
    <>
      <div className="flex">
        <div className="" style={{ width: '136px' }}>
          <div className="fs-2 c-grey-90 fw-500">{title1}</div>
        </div>
        <div className="flex flex-1 flex-column">
          <div className="flex flex-1">
            <div className="fs-2 c-grey-70 flex flex-1">{timeSegement[0]}</div>
            <div className="fs-2 c-grey-70 flex flex-1" style={{ flex: '1.4' }}>
              {timeSegement[1]}
            </div>
            <div className="fs-2 c-grey-70 flex flex-1" style={{ flex: '1.3' }}>
              {timeSegement[2]}
            </div>
            <div className="fs-2 c-grey-70 flex-1">{timeSegement[3]}</div>
            <div className="fs-2 c-grey-70" style={{ marginRight: '2px' }}>
              {timeSegement[4]}
            </div>
          </div>
          <Spacer className="mt-2" />
          <div className="flex flex-1 flex-around">
            <div
              className="flex-1 mr-1"
              style={{
                height: '6px',
                borderRadius: '3px',
                backgroundColor: 'grey'
              }}
            />
            <div
              className="flex-1 mr-1"
              style={{
                height: '6px',
                borderRadius: '3px',
                backgroundColor: '#58a65c'
              }}
            />
            <div
              className="flex-1 mr-1"
              style={{
                height: '6px',
                borderRadius: '3px',
                backgroundColor: '#f2bf42'
              }}
            />
            <div
              className="flex-1"
              style={{
                height: '6px',
                borderRadius: '3px',
                backgroundColor: '#d85040'
              }}
            />
          </div>
        </div>
      </div>
      <Spacer className="mt-3" />
      <div className="flex">
        <div style={{ width: '136px' }}>
          <div className="fs-2 c-grey-90 fw-500">{title2}</div>
        </div>
        <div className="flex flex-1 flex-around">
          <div className="fs-2 c-grey-70 flex-1 ta-center flex flex-center mr-1">
            <div className={`flex flex-middle fw-500 ${!showInfo ? 'mr-2' : ''}`}>
              {!showInfo && priceSegment[0] === NON_CHANGEABLE ? (
                NON_CHANGEABLE
              ) : (
                <>
                  {getCurrencyByReq(priceSegment[0], currency)}
                  {!showInfo ? ' (Per Adult)+ Fare Difference' : ''}
                </>
              )}
            </div>

            <div className="flex flex-middle ml-1 mt-1">
              <If condition={showInfo && tooltipContentSegment[0] && !isRefundFareRule}>
                <ToolTip
                  onOpenCallBack={() => onFareRulesClick(tooltipContentSegment[0])}
                  accessingPoint={<SVGComponent svgIcon="greyInfoIcon" className="c-grey-70" />}
                  toolTipStyle="farerule-tool-tip"
                  toolTipWidth="w-350"
                  toolTipBody={(
                    <If condition={currentTooltipData}>

                      {getTooltipContent(tooltipContentSegment[0], priceSegment[0])}
                    </If>
                  )}

                />
              </If>
            </div>
          </div>
          <div className="fs-2 c-grey-70 flex-1 ta-center flex flex-center mr-1">
            <div className="flex flex-middle fw-500">
              {!showInfo && priceSegment[1] === NON_CHANGEABLE ? (
                NON_CHANGEABLE
              ) : (
                <>
                  {getCurrencyByReq(priceSegment[1], currency)}
                  {!showInfo ? ' (Per Adult)+  Fare Difference' : ''}
                </>
              )}
            </div>
            <div className="flex flex-middle ml-1 mt-1">
              <If condition={showInfo && tooltipContentSegment[1] && !isRefundFareRule}>
                <ToolTip
                  onOpenCallBack={() => onFareRulesClick(tooltipContentSegment[1])}
                  accessingPoint={<SVGComponent svgIcon="greyInfoIcon" className="c-grey-70" />}
                  toolTipStyle="farerule-tool-tip"
                  toolTipWidth="w-350"
                  toolTipBody={(
                    <If condition={currentTooltipData}>

                      {getTooltipContent(tooltipContentSegment[1], priceSegment[1])}
                    </If>
                  )}
                />
              </If>
            </div>
          </div>
          <div className="fs-2 c-grey-70 flex-1 ta-center flex flex-center mr-1">
            <div className="flex flex-middle fw-500">
              {!showInfo && priceSegment[2] === NON_CHANGEABLE ? (
                NON_CHANGEABLE
              ) : (
                <>
                  {getCurrencyByReq(priceSegment[2], currency)}
                  {!showInfo ? ' (Per Adult)+ Fare Difference' : ''}
                </>
              )}
            </div>
            <div className="flex flex-middle ml-1 mt-1">
              <If condition={showInfo && tooltipContentSegment[2] && !isRefundFareRule}>
                <ToolTip
                  onOpenCallBack={() => onFareRulesClick(tooltipContentSegment[2])}
                  accessingPoint={<SVGComponent svgIcon="greyInfoIcon" className="c-grey-70" />}
                  toolTipStyle="farerule-tool-tip"
                  toolTipWidth="w-350"
                  toolTipBody={(
                    <If condition={currentTooltipData}>

                      {getTooltipContent(tooltipContentSegment[2], priceSegment[2])}
                    </If>
                  )}
                />
              </If>
            </div>
          </div>
          <div className="fs-2 c-grey-70 flex-1 ta-center flex flex-center">
            <div className="flex flex-middle fw-500">
              {!showInfo && priceSegment[3] === NON_CHANGEABLE ? (
                NON_CHANGEABLE
              ) : (
                <>
                  {getCurrencyByReq(priceSegment[3], currency)}
                  {!showInfo ? ' (Per Adult)+ Fare Difference' : ''}
                </>
              )}
            </div>
            <div className="flex flex-middle ml-1 mt-1">
              <If condition={showInfo && tooltipContentSegment[3] && !isRefundFareRule}>
                <ToolTip
                  onOpenCallBack={() => onFareRulesClick(tooltipContentSegment[3])}
                  accessingPoint={<SVGComponent svgIcon="greyInfoIcon" className="c-grey-70" />}
                  toolTipStyle="farerule-tool-tip"
                  toolTipWidth="w-350"
                  toolTipBody={(
                    <If condition={currentTooltipData}>

                      {getTooltipContent(tooltipContentSegment[3], priceSegment[3])}
                    </If>
                  )}
                />
              </If>
            </div>
          </div>
        </div>
      </div>
    </>
  )

  const getThreeSegmentBlock = (
    title1,
    title2,
    timeSegement = [],
    priceSegment = [],
    tooltipContentSegment = [],
    showInfo = false
  ) => (
    <>
      <div className="flex">
        <div className="" style={{ width: '136px' }}>
          <div className="fs-2 c-grey-90 fw-500">{title1}</div>
        </div>
        <div className="flex flex-1 flex-column">
          <div className="flex flex-1">
            <div className="fs-2 c-grey-70 flex flex-1"> {timeSegement[0]}</div>
            <div className="fs-2 c-grey-70 flex flex-1" style={{ flex: 1.25 }}>
              {timeSegement[1]}
            </div>
            <div className="fs-2 c-grey-70 flex flex-1">{timeSegement[2]}</div>
            <div className="fs-2 c-grey-70" style={{ marginRight: '2px' }}>
              {timeSegement[3]}
            </div>
          </div>
          <Spacer className="mt-2" />
          <div className="flex flex-1 flex-around">
            <div
              className="flex-1 mr-1"
              style={{
                height: '6px',
                borderRadius: '3px',
                backgroundColor: '#58a65c'
              }}
            />
            <div
              className="flex-1 mr-1"
              style={{
                height: '6px',
                borderRadius: '3px',
                backgroundColor: '#f2bf42'
              }}
            />
            <div
              className="flex-1"
              style={{
                height: '6px',
                borderRadius: '3px',
                backgroundColor: '#d85040'
              }}
            />
          </div>
        </div>
      </div>
      <Spacer className="mt-3" />
      <div className="flex">
        <div className="" style={{ width: '136px' }}>
          <div className="fs-2 c-grey-90 fw-500">{title2}</div>
        </div>
        <div className="flex flex-1 flex-around">
          <div className="fs-2 c-grey-70 flex-1 ta-center flex flex-center mr-1">
            <div className={`flex flex-middle fw-500 ${!showInfo ? 'mr-2' : ''}`}>
              {!showInfo && priceSegment[0] === NON_CHANGEABLE ? (
                NON_CHANGEABLE
              ) : (
                <>
                  {getCurrencyByReq(priceSegment[0], currency)}
                  {!showInfo ? ' (Per Adult)+ Fare Difference' : ''}
                </>
              )}
            </div>
            <div className="flex flex-middle ml-1 mt-1">
              <If condition={showInfo && tooltipContentSegment[0] && !isRefundFareRule}>
                <ToolTip
                  onOpenCallBack={() => onFareRulesClick(tooltipContentSegment[0])}
                  accessingPoint={<SVGComponent svgIcon="greyInfoIcon" className="c-grey-70" />}
                  toolTipStyle="farerule-tool-tip"
                  toolTipWidth="w-350"
                  toolTipBody={(
                    <If condition={currentTooltipData}>

                      {getTooltipContent(tooltipContentSegment[0], priceSegment[0])}
                    </If>
                  )}
                />
              </If>
            </div>
          </div>
          <div className="fs-2 c-grey-70 flex-1 ta-center flex flex-center mr-1">
            <div className="flex flex-middle fw-500">
              {!showInfo && priceSegment[1] === NON_CHANGEABLE ? (
                NON_CHANGEABLE
              ) : (
                <>
                  {getCurrencyByReq(priceSegment[1], currency)}
                  {!showInfo ? ' (Per Adult)+ Fare Difference' : ''}
                </>
              )}
            </div>
            <div className="flex flex-middle ml-1 mt-1">
              <If condition={showInfo && tooltipContentSegment[1] && !isRefundFareRule}>
                <ToolTip
                  onOpenCallBack={() => onFareRulesClick(tooltipContentSegment[1])}
                  accessingPoint={<SVGComponent svgIcon="greyInfoIcon" className="c-grey-70" />}
                  toolTipStyle="farerule-tool-tip"
                  toolTipWidth="w-350"
                  toolTipBody={(
                    <If condition={currentTooltipData}>

                      {getTooltipContent(tooltipContentSegment[1], priceSegment[1])}
                    </If>
                  )}
                />
              </If>
            </div>
          </div>
          <div className="fs-2 c-grey-70 flex-1 ta-center flex flex-center">
            <div className="flex flex-middle fw-500">
              {!showInfo && priceSegment[2] === NON_CHANGEABLE ? (
                NON_CHANGEABLE
              ) : (
                <>
                  {getCurrencyByReq(priceSegment[2], currency)}
                  {!showInfo ? ' (Per Adult)+ Fare Difference' : ''}
                </>
              )}
            </div>
            <div className="flex flex-middle ml-1 mt-1">
              <If condition={showInfo && tooltipContentSegment[2] && !isRefundFareRule}>
                <ToolTip
                  onOpenCallBack={() => onFareRulesClick(tooltipContentSegment[2])}
                  accessingPoint={<SVGComponent svgIcon="greyInfoIcon" className="c-grey-70" />}
                  toolTipStyle="farerule-tool-tip"
                  toolTipWidth="w-350"
                  toolTipBody={(
                    <If condition={currentTooltipData}>

                      {getTooltipContent(tooltipContentSegment[2], priceSegment[2])}
                    </If>
                  )}
                />
              </If>
            </div>
          </div>
        </div>
      </div>
    </>
  )

  const getTwoSegmentBlock = (
    title1,
    title2,
    timeSegement = [],
    priceSegment = [],
    tooltipContentSegment = [],
    showInfo = false
  ) => (
    <>
      <div className="flex">
        <div className="" style={{ width: '136px' }}>
          <div className="fs-2 c-grey-90 fw-500">{title1}</div>
        </div>
        <div className="flex flex-1 flex-column">
          <div className="flex flex-1">
            <div
              className="fs-2 c-grey-70 flex flex-1"
              style={{
                flex: 2.22
              }}
            >
              {timeSegement[0]}
            </div>
            <div className="fs-2 c-grey-70 flex flex-1">{timeSegement[1]}</div>
            <div className="fs-2 c-grey-70" style={{ marginRight: '2px' }}>
              {timeSegement[2]}
            </div>
          </div>
          <Spacer className="mt-2" />
          <div className="flex flex-1 flex-around">
            <div
              className="flex-1 mr-1"
              style={{
                height: '6px',
                borderRadius: '3px',
                backgroundColor: '#f2bf42',
                flex: 2
              }}
            />
            <div
              className="flex-1"
              style={{
                height: '6px',
                borderRadius: '3px',
                backgroundColor: '#d85040'
              }}
            />
          </div>
        </div>
      </div>
      <Spacer className="mt-3" />
      <div className="flex">
        <div style={{ width: '136px' }}>
          <div className="fs-2 c-grey-90 fw-500">{title2}</div>
        </div>
        <div className="flex flex-1 flex-around">
          <div className="fs-2 c-grey-70 flex-1 ta-center flex flex-center mr-1" style={{ flex: 2 }}>
            <div className={`flex flex-middle fw-500 ${!showInfo ? 'mr-2' : ''}`}>

              {!showInfo && priceSegment[0] === NON_CHANGEABLE ? (
                NON_CHANGEABLE
              ) : (
                <>
                  {getCurrencyByReq(priceSegment[0], currency)}
                  {!showInfo ? ' (Per Adult)+ Fare Difference' : ''}
                </>
              )}
            </div>
            <div className="flex flex-middle ml-1 mt-1">
              <If condition={showInfo && tooltipContentSegment[0] && !isRefundFareRule}>
                <ToolTip
                  onOpenCallBack={() => onFareRulesClick(tooltipContentSegment[0])}
                  accessingPoint={<SVGComponent svgIcon="greyInfoIcon" className="c-grey-70" />}
                  toolTipStyle="farerule-tool-tip"
                  toolTipWidth="w-350"
                  toolTipBody={(
                    <If condition={currentTooltipData}>

                      {getTooltipContent(tooltipContentSegment[0], priceSegment[0])}
                    </If>
                  )}
                />
              </If>
            </div>
          </div>
          <div className="fs-2 c-grey-70 flex-1 ta-center flex flex-center">
            <div className="flex flex-middle fw-500">
              {!showInfo && priceSegment[1] === NON_CHANGEABLE ? (
                NON_CHANGEABLE
              ) : (
                <>
                  {getCurrencyByReq(priceSegment[1], currency)}
                  {!showInfo ? ' (Per Adult)+ Fare Difference' : ''}
                </>
              )}
            </div>
            <div className="flex flex-middle ml-1 mt-1">
              <If condition={showInfo && tooltipContentSegment[1] && !isRefundFareRule}>
                <ToolTip
                  onOpenCallBack={() => onFareRulesClick(tooltipContentSegment[1])}
                  accessingPoint={<SVGComponent svgIcon="greyInfoIcon" className="c-grey-70" />}
                  toolTipStyle="farerule-tool-tip"
                  toolTipWidth="w-350"
                  toolTipBody={(
                    <If condition={currentTooltipData}>

                      {getTooltipContent(tooltipContentSegment[1], priceSegment[1])}
                    </If>
                  )}
                />
              </If>
            </div>
          </div>
        </div>
      </div>
    </>
  )

  const getOneSegmentBlock = (
    title1,
    title2,
    timeSegement = [],
    priceSegment = [],
    tooltipContentSegment = [],
    showInfo = false
  ) => (
    <>
      <div className="flex">
        <div className="" style={{ width: '136px' }}>
          <div className="fs-2 c-grey-90 fw-500">{title1}</div>
        </div>
        <div className="flex flex-1 flex-column">
          <div className="flex flex-1">
            <div className="fs-2 c-grey-70 flex flex-1">{timeSegement[0]}</div>
            <div className="fs-2 c-grey-70" style={{ marginRight: '2px' }}>
              {timeSegement[1]}
            </div>
          </div>
          <Spacer className="mt-2" />
          <div className="flex flex-1 flex-around">
            <div
              className="flex-1"
              style={{
                height: '6px',
                borderRadius: '3px',
                backgroundColor: '#d85040'
              }}
            />
          </div>
        </div>
      </div>
      <Spacer className="mt-3" />
      <div className="flex">
        <div style={{ width: '136px' }}>
          <div className="fs-2 c-grey-90 fw-500">{title2}</div>
        </div>
        <div className="flex flex-1 flex-around">
          <div className="fs-2 c-grey-70 flex-1 ta-center flex flex-center">
            <div className="flex flex-middle fw-500">
              {!showInfo && priceSegment[0] === NON_CHANGEABLE ? (
                NON_CHANGEABLE
              ) : (
                <>
                  {getCurrencyByReq(priceSegment[0], currency)}
                  {!showInfo ? ' (Per Adult)+ Fare Difference' : ''}
                </>
              )}
            </div>
            <div className="flex flex-middle ml-1 mt-1">
              <If condition={showInfo && tooltipContentSegment[0] && !isRefundFareRule}>
                <ToolTip
                  onOpenCallBack={() => onFareRulesClick(tooltipContentSegment[0])}
                  accessingPoint={<SVGComponent svgIcon="greyInfoIcon" className="c-grey-70" />}
                  toolTipStyle="farerule-tool-tip"
                  toolTipWidth="w-350"
                  toolTipBody={(
                    <If condition={currentTooltipData}>

                      {getTooltipContent(tooltipContentSegment[0], priceSegment[0])}
                    </If>
                  )}
                />
              </If>
            </div>
          </div>
        </div>
      </div>
    </>
  )

  const collateExtaBlocks = (
    title1,
    title2,
    timeSegement = [],
    priceSegment = [],
    tooltipContentSegment = [],
    showInfo = false
  ) => {
    const updatedPriceSegment = priceSegment.slice(-4)
    const updatedTimeSegement = timeSegement.slice(-5)
    const updatedTooltipContentSegment = tooltipContentSegment.slice(-4)
    return getFourSegmentBlock(
      title1,
      title2,
      updatedTimeSegement,
      updatedPriceSegment,
      updatedTooltipContentSegment,
      showInfo
    )
  }

  if (fareRules) {
    const { cancelCharges = [], amendCharges = [] } = fareRules || {}

    const tooltipContentSegment = []
    if (cancelCharges && cancelCharges.length > 0) {
      const timeSegement = []
      const priceSegment = []
      const blockSegments = cancelCharges.length
      cancelCharges.forEach((cancelCharge, idx) => {
        const { timeline = {}, refundableAmount, chargesBreakup = [] } = cancelCharge
        if (idx === 0) {
          timeSegement.push(timeline.startTimeDate)
        }
        timeSegement.push(timeline.endTimeDate)
        priceSegment.push(refundableAmount)
        tooltipContentSegment.push(chargesBreakup)
      })
      cancelationPolicyBlock =
        blockSegments === 1 ?
          getOneSegmentBlock(
            CANCEL_BETWEEN,
            AMOUNT_REFUNDABLE,
            timeSegement,
            priceSegment,
            tooltipContentSegment,
            true
          ) :
          blockSegments === 2 ?
            getTwoSegmentBlock(
              CANCEL_BETWEEN,
              AMOUNT_REFUNDABLE,
              timeSegement,
              priceSegment,
              tooltipContentSegment,
              true
            ) :
            blockSegments === 3 ?
              getThreeSegmentBlock(
                CANCEL_BETWEEN,
                AMOUNT_REFUNDABLE,
                timeSegement,
                priceSegment,
                tooltipContentSegment,
                true
              ) :
              blockSegments > 3 ?
                collateExtaBlocks(
                  CANCEL_BETWEEN,
                  AMOUNT_REFUNDABLE,
                  timeSegement,
                  priceSegment,
                  tooltipContentSegment,
                  true
                ) :
                ''
    }
    if (amendCharges && amendCharges.length > 0) {
      const blockSegments = amendCharges.length
      const timeSegement = []
      const priceSegment = []
      amendCharges.forEach((rule, idx) => {
        const { timeline, amendSameFareCharges = [] } = rule
        if (idx === 0) {
          timeSegement.push(timeline.startTimeDate)
        }
        timeSegement.push(timeline.endTimeDate)
        let amendAdtSameFare
        if (amendSameFareCharges) {
          amendAdtSameFare = amendSameFareCharges.filter(
            fareCharges => {
              return fareCharges && fareCharges.paxType === 'ADT'
            }
          )
        }

        const { dateChangeCharge, nonAmend = false } = amendAdtSameFare[0] || {}
        if (nonAmend) {
          priceSegment.push(NON_CHANGEABLE)
        } else {
          priceSegment.push(dateChangeCharge)
        }
      })
      dateChangePolicyBlock =
        blockSegments === 1 ?
          getOneSegmentBlock(
            CHANGE_BETWEEN, DATE_CHANGE_CHARGES, timeSegement, priceSegment) :
          blockSegments === 2 ?
            getTwoSegmentBlock(
              CHANGE_BETWEEN, DATE_CHANGE_CHARGES, timeSegement, priceSegment) :
            blockSegments === 3 ?
              getThreeSegmentBlock(
                CHANGE_BETWEEN, DATE_CHANGE_CHARGES, timeSegement, priceSegment) :
              blockSegments > 3 ?
                collateExtaBlocks(
                  CHANGE_BETWEEN, DATE_CHANGE_CHARGES, timeSegement, priceSegment) :
                ''
    }
  }
  const cancellationRenderedBlock = () => {
    return (
      <div>
        {isRefundFareRule && (
          <div className="flex flex-middle flex-between pt-0012 pb-0012 h-40 pl-0016 pr-0016">
            <p className="fs-14 fw-500">Cancellation Charges</p>
          </div>
        )}
        <div className="flex flex-1 pt-2 pb-6 pl-4 pr-7 flex-column">
          {cancelationPolicyBlock}
        </div>
      </div>
    )
  }

  return (

    <div
      className="flex flex-column"
    >
      <>
        {isRefundFareRule && (
          <div className="flex flex-middle flex-between pt-0012 pb-0012 h-40 pl-0016 pr-0016" style={{ backgroundColor: '#f6f6f8' }}>
            <p className="fs-14 fw-500">Fare Rule</p>

            <span onClick={() => onClose()}>
              <Cross fill="#4d4d4d" />
            </span>
          </div>
        )}
        {
          !isSplRt && (
            <div className="flex flex-between  ">

              <div className={`flex flex-middle px-4 flex-1 ${marginTop || ''}`}>
                {/* <p className="fs-4 c-neutral-900 fw-700 lh-title">{fareDisplayName}</p> */}
                <div className="fs-body  fw-700 lh-title">{departureCity}</div>
                <div className="fs-body  fw-700 lh-title mx-1">→</div>
                <div className="fs-body  fw-700 lh-title mx-1">{arrivalCity}</div>
                <div className="fs-body  fw-700 lh-title mx-1">:</div>
                <div className="fs-body  fw-700 lh-title">{departureTime}</div>
              </div>
            </div>
          )
        }

        {
          isSplRt && cancelationPolicyBlock && disclaimerText && (indexOfFaq === 0) && (
            <div className="bg-warning-100 br-10 flex flex-top mb-2 mx-5 p-3">
              <div>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">

                  <g mask="url(#mask0_2562_64576)">
                    <path d="M8 11C8.1 11 8.18067 10.9696 8.242 10.9087C8.30289 10.8473 8.33333 10.7667 8.33333 10.6667V7.65C8.33333 7.56111 8.3 7.486 8.23333 7.42467C8.16667 7.36378 8.08889 7.33333 8 7.33333C7.9 7.33333 7.81933 7.36667 7.758 7.43333C7.69711 7.5 7.66667 7.57778 7.66667 7.66667V10.6833C7.66667 10.7722 7.7 10.8473 7.76667 10.9087C7.83333 10.9696 7.91111 11 8 11ZM8 6.38333C8.11111 6.38333 8.20844 6.34444 8.292 6.26667C8.37511 6.18889 8.41667 6.08889 8.41667 5.96667C8.41667 5.85556 8.37511 5.76111 8.292 5.68333C8.20844 5.60556 8.11111 5.56667 8 5.56667C7.88889 5.56667 7.79156 5.60556 7.708 5.68333C7.62489 5.76111 7.58333 5.85556 7.58333 5.96667C7.58333 6.08889 7.62489 6.18889 7.708 6.26667C7.79156 6.34444 7.88889 6.38333 8 6.38333ZM8 14C7.16667 14 6.38333 13.8444 5.65 13.5333C4.91667 13.2222 4.28067 12.7973 3.742 12.2587C3.20289 11.7196 2.77778 11.0833 2.46667 10.35C2.15556 9.61667 2 8.83333 2 8C2 7.16667 2.15556 6.38333 2.46667 5.65C2.77778 4.91667 3.20289 4.28044 3.742 3.74133C4.28067 3.20267 4.91667 2.77778 5.65 2.46667C6.38333 2.15556 7.16667 2 8 2C8.83333 2 9.61667 2.15556 10.35 2.46667C11.0833 2.77778 11.7196 3.20267 12.2587 3.74133C12.7973 4.28044 13.2222 4.91667 13.5333 5.65C13.8444 6.38333 14 7.16667 14 8C14 8.83333 13.8444 9.61667 13.5333 10.35C13.2222 11.0833 12.7973 11.7196 12.2587 12.2587C11.7196 12.7973 11.0833 13.2222 10.35 13.5333C9.61667 13.8444 8.83333 14 8 14ZM8 13.3333C9.47778 13.3333 10.7362 12.814 11.7753 11.7753C12.814 10.7362 13.3333 9.47778 13.3333 8C13.3333 6.52222 12.814 5.26378 11.7753 4.22467C10.7362 3.186 9.47778 2.66667 8 2.66667C6.52222 2.66667 5.264 3.186 4.22533 4.22467C3.18622 5.26378 2.66667 6.52222 2.66667 8C2.66667 9.47778 3.18622 10.7362 4.22533 11.7753C5.264 12.814 6.52222 13.3333 8 13.3333Z" fill="#1A1A1A" />
                  </g>
                </svg>
              </div>
              <p className="pl-2 fs-2">{disclaimerTextArray[0]}<b>{disclaimerTextArray[1]}</b>{disclaimerTextArray[2]}</p>
            </div>
          )
        }
        {
          !isSplRt ?
            cancelationPolicyBlock && cancellationRenderedBlock() :
            cancelationPolicyBlock && (indexOfFaq === 0) && cancellationRenderedBlock()
        }

        {dateChangePolicyBlock && (
          <div>
            {isRefundFareRule && (
              <div className="flex flex-middle flex-between pt-0012 pb-0012 h-40 pl-0016 pr-0016">
                <p className="fs-14 fw-500">Date Change Charges</p>

              </div>
            )}
            <div className="flex flex-1 pt-2 pb-6 pl-4 pr-7 flex-column">
              {dateChangePolicyBlock}
            </div>
          </div>

        )}

      </>

    </div>

  )
}

export default FareRulesWidget
